import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React from 'react';

const DialogHeader = ({ heading, onClose }) => {
  return (
    <>
      <DialogTitle id="dialog-title-2" className="col1 card_title">
        {heading}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 2,
          top: 2,
        }}
      >
        <HighlightOffIcon fontSize="small" className="gray" />
      </IconButton>
    </>
  );
};

export default DialogHeader;
